import React from "react";
import { Box } from "@mui/material";

export function formatMoney(amount, currency = "INR", opts = {}) {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(opts.locale || "en-IN", {
      style: "currency",
      currency,
      minimumFractionDigits: opts.digits ?? 2,
      maximumFractionDigits: opts.digits ?? 2,
    }).format(n);
  } catch {
    return `₹${n.toLocaleString("en-IN")}`;
  }
}

export default function Money({ amount, currency = "INR", digits = 2, color, bold, large, compact }) {
  const formatted = compact && Math.abs(Number(amount || 0)) >= 100000
    ? `₹${(Number(amount || 0) / 100000).toFixed(1)}L`
    : formatMoney(amount, currency, { digits });
  return (
    <Box component="span" sx={{ fontWeight: bold ? 600 : 400, color, fontSize: large ? 22 : undefined, fontVariantNumeric: "tabular-nums" }}>
      {formatted}
    </Box>
  );
}
